import { fromJS, Set } from 'immutable';

import {
  CHANGE_TASK_SIDEBAR,
  LOAD_TASK_LIST_SUCCESS,
  LOAD_SUBTASKS_LIST_SUCCESS,
  SELECT_TASK_BATCH,
  CLEAR_TASK_BATCH,
  REMOVE_TASK_BATCH,
  SELECT_ALL_TASKS_BATCH,
  UPDATE_TASKS_SUCCESS,
} from 'constants/ActionTypes';

import { getSubTaskIds } from 'helpers/taskHelpers';

const initialState = fromJS({
  sidebarCollapsed: false,
  datasets: {},
  dataset: [],
  datasetIsPrivate: [],
  batchIds: Set(),
  paginations: {},
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const taskListReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TASK_LIST_SUCCESS: {
      const parentId = action.action.payload.filters.parentId?.value;
      const dataset = fromJS(action.tasks.items.map((task) => task.taskId));
      const datasetIsPrivate = Set(action.tasks.items.filter((task) => task.isPrivate).map((task) => task.taskId));
      const counters = fromJS(action.tasks._meta.counters);
      const pagination = fromJS({
        totalCount: action.tasks._meta.totalCount,
        pageCount: action.tasks._meta.pageCount,
        currentPage: action.tasks._meta.currentPage,
        perPage: action.tasks._meta.perPage,
      });

      if (parentId === 'parent') {
        return state
          .set('counters', counters)
          .set('dataset', dataset)
          .set('datasetIsPrivate', datasetIsPrivate)
          .set('pagination', pagination)
          .set('datasets', initialState.get('datasets'))
          .set('paginations', initialState.get('paginations'));
      }

      if (parentId) {
        let newState = state.set('datasetIsPrivate', state.get('datasetIsPrivate').union(datasetIsPrivate));
        if (pagination.get('currentPage') === 1) {
          return newState.setIn(['datasets', parentId], dataset).setIn(['paginations', parentId], pagination);
        }

        return newState
          .setIn(['datasets', parentId], state.getIn(['datasets', parentId]).merge(dataset))
          .setIn(['paginations', parentId], pagination);
      }

      return state;
    }
    case LOAD_SUBTASKS_LIST_SUCCESS: {
      if (action.task?.subTasks) {
        let dataset = state.get('dataset');
        action.task.subTasks.forEach((subTask) => {
          dataset = dataset.push(subTask.taskId);
          if (subTask.subTasks) {
            subTask.subTasks.forEach((subSubTask) => (dataset = dataset.push(subSubTask.taskId)));
          }
        });
        return state.set('dataset', dataset);
      }
      return state;
    }
    case CHANGE_TASK_SIDEBAR:
      return state.set('sidebarCollapsed', !state.get('sidebarCollapsed'));
    case CLEAR_TASK_BATCH: {
      return state.set('batchIds', initialState.get('batchIds'));
    }
    case REMOVE_TASK_BATCH: {
      return state.set(
        'batchIds',
        state.get('batchIds').filter((taskId) => taskId !== action.taskId),
      );
    }
    case SELECT_TASK_BATCH: {
      let batchIds = state.get('batchIds');
      batchIds = batchIds.add(action.taskId);
      const subTaskIds = getSubTaskIds(state.get('datasets'), action.taskId);
      if (!subTaskIds.size) {
        return state.set('batchIds', batchIds);
      }

      let ids = Set();
      const stateBatchIds = state.get('batchIds');
      for (const subId of subTaskIds) {
        if (stateBatchIds.has(subId)) {
          return state.set('batchIds', batchIds);
        }

        ids = ids.add(subId);
      }

      // unselect isPrivate task
      batchIds = batchIds.union(ids);
      return state.set('batchIds', batchIds);
    }
    case SELECT_ALL_TASKS_BATCH: {
      let batchIds = state.get('batchIds').union(state.get('dataset'));
      state
        .get('datasets')
        .keySeq()
        .forEach((id) => {
          batchIds = batchIds.add(id).union(state.get('datasets').get(id));
        });

      return state.set('batchIds', batchIds);
    }
    case UPDATE_TASKS_SUCCESS: {
      if (!action.isDelete) {
        return state;
      }

      let batchIds = state.get('batchIds').filter((taskId) => !state.get('datasetIsPrivate').has(taskId));
      for (const task of action.tasks.items) {
        batchIds = batchIds.delete(task.taskId);
      }

      return state.set('batchIds', batchIds);
    }
    default:
      return state;
  }
};

export default taskListReducer;
